import { Button, ButtonGroup } from "@components/button";
import { IPrAnnualTaxSettlementEntity } from "@odata/GeneratedEntityTypes";
import { PrAnnualTaxSettlementStatusCode } from "@odata/GeneratedEnums";
import { cloneDeep } from "lodash";
import React from "react";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend } from "../../../views/formView/FormView";

class AnnualTaxSettlementFormView extends FormViewForExtend<IPrAnnualTaxSettlementEntity> {
    static defaultProps = {
        formProps: {
            shouldHideAuditTrail: true,
            shouldHideVariant: true
        }
    };

    renderButtons(): React.ReactElement {
        const storage = this.props.storage;
        const isFormReadOnly = storage.isReadOnly;
        const canBeSaved = [PrAnnualTaxSettlementStatusCode.ToCheck, PrAnnualTaxSettlementStatusCode.Checked].includes(this.entity.StatusCode);
        const saveTranslationKey = this.entity.StatusCode === PrAnnualTaxSettlementStatusCode.ToCheck
            ? "AnnualTaxSettlement:Form.CheckAndLock"
            : "AnnualTaxSettlement:Form.Unlock";

        return (
            <ButtonGroup wrap={"wrap"}>
                <Button hotspotId={"formCancel"}
                        isDisabled={storage.isDisabled || this.shouldDisableCancelButton()}
                        onClick={this.handleFormCancel}
                        isTransparent>{storage.t("Common:General.Cancel")}</Button>
                {!isFormReadOnly && canBeSaved &&
                    <Button hotspotId={"formSave"}
                            onClick={this.handleSaveClick}
                            isDisabled={this.shouldDisableSaveButton()}>
                        {storage.t(saveTranslationKey)}
                    </Button>
                }
            </ButtonGroup>
        );
    }

    onBeforeSave(): IPrAnnualTaxSettlementEntity {
        const data = cloneDeep(this.entity);
        if (this.entity.StatusCode === PrAnnualTaxSettlementStatusCode.ToCheck) {
            data.StatusCode = PrAnnualTaxSettlementStatusCode.Checked;
        } else if (this.entity.StatusCode === PrAnnualTaxSettlementStatusCode.Checked) {
            data.StatusCode = PrAnnualTaxSettlementStatusCode.ToCheck;
        }
        return data;
    }
}

export default withPermissionContext(AnnualTaxSettlementFormView);